import { render, staticRenderFns } from "./AppDrawerMobile.vue?vue&type=template&id=de2fb84a&"
import script from "./AppDrawerMobile.vue?vue&type=script&lang=js&"
export * from "./AppDrawerMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports